<template>
  <div>
    <Title :pages="[{ icon: 'triangle-exclamation', page: 'INCIDENCIAS' }]"></Title>
    <v-container fluid>
      <v-card class="mb-4">
        <div class="row mb-2 ps-3 pe-3 mt-0 mb-2">
          <div class="col-md-12">
            <div class="col-md-12" style="background: white">
              <p class="text-h6 mt-2 mb-0"><font-awesome-icon icon="filter" class="pr-2" />Filtros</p>
              <v-divider class="mt-0"></v-divider>
              <div class="row pt-2">
                <div class="col-md-3">
                  <v-text-field v-model="filters.creation_date_from" density="comfortable" type="date" label="Desde"></v-text-field>
                </div>
                <div class="col-md-3">
                  <v-text-field v-model="filters.creation_date_to" density="comfortable" type="date" label="Hasta"></v-text-field>
                </div>
                <div class="col-md-3">
                  <v-combobox v-model="filters.almacen" density="comfortable" item-title="name" item-value="id" :items="almacenes" label="Almacén" autocomplete="off" clearable :loading="loading_almacenes"></v-combobox>
                </div>
                <div class="col-md-3">
                  <v-text-field v-model="filters.shipment_order_code" density="comfortable" label="Número de Pedido"></v-text-field>
                </div>
                <div class="col-md-3">
                  <v-combobox v-model="filters.code" density="comfortable" item-title="name" item-value="id" :items="codes" label="Tipo de Incidencia" autocomplete="off" clearable></v-combobox>
                </div>
                <div class="col-md-3">
                  <v-combobox v-model="filters.state" density="comfortable" item-title="name" item-value="id" :items="states" label="Estado" autocomplete="off" clearable></v-combobox>
                </div>
                <div class="col-md-3">
                  <v-combobox v-model="filters.product" density="comfortable" item-title="label" item-value="id" :items="products" label="Producto" autocomplete="off" clearable></v-combobox>
                </div>
                <div class="col-md-3 pt-0 pb-3" style="display: flex; justify-content: end">
                  <v-btn color="info" @click="filter" prepend-icon="mdi-magnify">Buscar</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card>

      <v-card>
        <v-card-title>
          <v-row align="center" class="mt-1">
            <v-col cols="auto"><span>Incidencias</span></v-col>
            <v-spacer></v-spacer>
            <v-col>
              <v-text-field v-model="search" append-inner-icon="mdi-magnify" single-line hide-details label="Buscar" density="compact"></v-text-field>
            </v-col>
          </v-row>
        </v-card-title>

        <div class="mb-4 mt-2">
          <v-menu offset-y>
            <template v-slot:activator="{ props }">
              <v-icon @click="toggleClass" style="border: 1px solid; border-radius: 100px; padding: 3px" color="blue-grey" :class="isActiveBlinking ? 'ml-4 button_blinking' : 'ml-4'" v-bind="props">
                mdi-dots-vertical
              </v-icon>
            </template>

            <v-list>
              <v-list-item @click="openResolveMultiple">
                <v-list-item-title>Resolver incidencias</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>

        <v-data-table v-if="list_access" :items-per-page="0" :hide-default-footer="true" :headers="headers" :items="list" :search="search" :loading="loading" loading-text="Cargando..." v-model="selected" show-select item-value="id">
          <template v-slot:item="{ item, isSelected, toggleSelect }">
            <tr>
              <td class="pl-2">
                <v-checkbox
                  style="margin: 0px; padding: 0px"
                  hide-details
                  :model-value="isSelected({ value: item.id })"
                  @update:modelValue="toggleSelect({ value: item.id })"
                  :disabled="item.state.id === service.STATE_RESOLVED"
                />
              </td>
              <td>{{ item.id }}</td>
              <td>{{ item.picking_detail_id }}</td>

              <td>
                {{ item.creation_date }}<br />
                <span class="text-caption text-grey-600">{{ item.user_reported ? item.user_reported.name : "-" }}</span>
              </td>
              <td class="font-weight-bold">
                <span v-if="item.shipment_order_item">
                  {{ item.shipment_order_item.shipment_order.code }}
                </span>
                <span v-else>-</span>
              </td>

              <td>
                <span class="status-badge mb-0" :class="'code-' + item.code.id">
                  {{ item.code.name }}
                </span>
                <div class="text-caption text-grey-600">{{ item.reason_text || "-" }}</div>
              </td>

              <td>
                <div v-if="item.shipment_order_item && item.shipment_order_item.product" class="mt-1">
                  <div class="font-weight-bold">{{ item.shipment_order_item.product.name || "-" }}</div>
                  <div class="text-caption text-grey-600">SKU: {{ item.shipment_order_item.product.sku || "-" }}</div>
                  <div v-if="item.qty_found != null && item.qty_found !== ''" class="text-caption">{{ getQtyLabel(item.code) }}: {{ item.qty_found }}</div>
                  <div v-if="item.lpn_code" class="text-caption">LPN: {{ item.lpn_code }}</div>
                  <div v-if="item.ubicacion_code" class="text-caption">Ubicación: {{ item.ubicacion_code }}</div>
                </div>
                <div v-else>
                  <div>-</div>
                  <div v-if="item.qty_found != null && item.qty_found !== ''" class="text-caption">{{ getQtyLabel(item.code) }}: {{ item.qty_found }}</div>
                  <div v-if="item.lpn_code" class="text-caption">LPN: {{ item.lpn_code }}</div>
                  <div v-if="item.ubicacion_code" class="text-caption">Ubicación: {{ item.ubicacion_code }}</div>
                </div>
              </td>

              <td>
                <span class="status-badge" :class="item.state.id === service.STATE_RESOLVED ? 'status-resolved' : 'status-unresolved'">
                  {{ item.state.name }}
                </span>
              </td>

              <td class="text-center" style="min-width: 120px">
                <!-- Resolver incidencia -->
                <v-tooltip bottom v-if="item.state.id === service.STATE_NOT_RESOLVED">
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props" small color="success" class="mr-2" v-on:click="openResolveDialog(item)" size="small"> mdi-check-circle-outline </v-icon>
                  </template>
                  <span>Resolver incidencia</span>
                </v-tooltip>

                <!-- Ver fotos -->
                <v-tooltip bottom v-if="item.photos && item.photos.length">
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props" small color="blue" class="mr-2" v-on:click="openPhotos(item)" size="small"> mdi-image-multiple </v-icon>
                  </template>
                  <span>Ver fotos</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>

      <div class="text-right mt-2">
        <small class="text-grey">
          {{ paginationText }}
        </small>
      </div>
      <v-pagination
        v-if="cant_pages > 1"
        v-model="current_page"
        :length="cant_pages"
        total-visible="10"
        @update:modelValue="loadPage(service)"
        class="mt-4"
      ></v-pagination>
    </v-container>

    <!-- Modal Confirmación Resolver -->
    <DialogYesNo
      :open="dialog_resolve"
      :title="'Resolver Incidencia' + (selected_to_resolve.length > 1 ? 's' : '')"
      :message="resolveMessage"
      :loading="loadingSubmit"
      @accept="confirmResolve"
      @cancel="closeResolveDialog"
    />

    <!-- Modal fotos -->
    <v-dialog v-model="dialog_photos" max-width="700">
      <v-card>
        <v-card-title class="headline">
          <span>Fotos de la incidencia</span>
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col v-for="(photo, i) in selected_photos" :key="i" cols="12" md="4">
              <v-img :src="photo.photo_url" aspect-ratio="1" cover class="rounded" @click="openFullPhoto(photo.photo_url)" style="cursor: pointer"></v-img>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="closeModal()">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { incidenciaService } from "@/libs/ws/incidenciaService";
import { productoService } from "@/libs/ws/productoService";
import { almacenService } from "@/libs/ws/almacenService";
import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import DialogYesNo from "@/components/DialogYesNo.vue";

export default {
  components: { DialogYesNo },
  mixins: [GenericMixin, RolMixin],
  data() {
    return {
      service: incidenciaService,
      page_title: "Incidencias",
      codes: [],
      states: [],
      products: [],
      almacenes: [],
      loading_almacenes: false,
      selected: [],
      dialog_photos: false,
      selected_photos: [],
      dialog_resolve: false,
      selected_to_resolve: [],
      loadingSubmit: false,
      isActiveBlinking: false,
      headers: [
        { title: "Nº", key: "id", sortable: true },
        { title: "N° Tarea", key: "picking_detail_id", sortable: true },
        { title: "Fecha", key: "creation_date", sortable: true },
        { title: "Envio", key: "shipment_order", sortable: false },
        { title: "Tipo/Motivo", key: "code", sortable: true },
        { title: "Info Extra.", key: "", sortable: false },
        { title: "Estado", key: "state", sortable: true },
        { title: "Accion", key: "actions", sortable: false, align: "center" },
      ],
      filters: {
        creation_date_from: new Date(new Date().toLocaleDateString("en-US", { timeZone: "America/Buenos_Aires" })).toISOString().slice(0, 10),
        creation_date_to: new Date(new Date().toLocaleDateString("en-US", { timeZone: "America/Buenos_Aires" })).toISOString().slice(0, 10),
        shipment_order_code: "",
        code: null,
        state: null,
        product: null,
        almacen: null,
      },
    };
  },
  mounted() {
    this.filters.almacen = JSON.parse(localStorage.getItem("almacen"));
    this.filter();
    this.loadCodes();
    this.loadStates();
    this.loadProducts();
    this.loadAlmacenes();
  },
  watch: {
    selected: function () {
      if (this.selected.length > 0) {
        this.isActiveBlinking = true;
      } else {
        this.isActiveBlinking = false;
      }
    },
  },
  methods: {
    toggleClass() {
      this.isActiveBlinking = false;
    },
    getQtyLabel(code) {
      switch (code && code.id) {
        case "PRODUCT_DAMAGED":
          return "Cantidad dañado";
        case "PRODUCT_MISSING":
          return "Cantidad faltante";
        case "FORCED_CLOSE":
          return "Cantidad no pickeada";
        default:
          return "Cantidad";
      }
    },
    getFilterParams() {
      return {
        ...this.filters,
        code: this.filters.code ? this.filters.code.id : null,
        state: this.filters.state ? this.filters.state.id : null,
        product: this.filters.product ? this.filters.product.id : null,
        almacen: this.filters.almacen ? this.filters.almacen.id : null,
      };
    },
    filter() {
      this.current_page = 1;
      this.loadList(this.service, this.getFilterParams());
    },
    loadCodes() {
      incidenciaService.list_codes().then((response) => {
        this.codes = response.result;
      });
    },
    loadStates() {
      incidenciaService.list_states().then((response) => {
        this.states = response.result;
      });
    },
    loadProducts() {
      productoService.list_minify().then((response) => {
        this.products = response.result.list;
      });
    },
    loadAlmacenes() {
      this.loading_almacenes = true;
      almacenService
        .filter({})
        .then((response) => {
          this.almacenes = response.result.list;
        })
        .finally(() => {
          this.loading_almacenes = false;
        });
    },
    openPhotos(item) {
      this.selected_photos = item.photos;
      this.dialog_photos = true;
    },
    openFullPhoto(url) {
      window.open(url, "_blank");
    },

    closeModal() {
      this.dialog_photos = false;
    },
    openResolveDialog(item) {
      this.selected_to_resolve = [item.id];
      this.dialog_resolve = true;
    },
    openResolveMultiple() {
      this.selected_to_resolve = [...this.selected];
      this.dialog_resolve = true;
    },
    closeResolveDialog() {
      this.dialog_resolve = false;
      this.selected_to_resolve = [];
    },
    async confirmResolve() {
      this.loadingSubmit = true;
      try {
        const response = await incidenciaService.resolve(this.selected_to_resolve);
        if (response.status) {
          this.toast.success(response.msg);
          this.selected = [];
          this.closeResolveDialog();
          this.filter();
        } else {
          this.toast.error(response.msg);
        }
      } catch (error) {
        this.toast.error("Error al resolver incidencias");
        console.error(error);
      } finally {
        this.loadingSubmit = false;
      }
    },
  },
  computed: {
    resolveMessage() {
      const count = this.selected_to_resolve.length;
      return count === 1 ? "¿Desea cambiar el estado de esta incidencia a resuelta?" : `¿Desea cambiar el estado de ${count} incidencias a resuelta?`;
    },
  },
};
</script>
